<template>
  <div>
    <v-card>
      <v-toolbar flat dark color="secondary">
        <v-toolbar-title :style="$store.state.textFormatting.headers">
          Developer Notes
        </v-toolbar-title>
        <v-spacer />
        <v-flex shrink>
          <v-btn
            @click="showCard = !showCard"
            v-if="showCard"
            dark
            fab
            small
            color="blue"
            ><h2>-</h2></v-btn
          >
          <v-btn
            @click="showCard = !showCard"
            v-if="!showCard"
            dark
            fab
            small
            color="blue"
            ><h2>+</h2></v-btn
          >
        </v-flex>
      </v-toolbar>
      <v-card-text class="body-2" v-if="showCard">
        <div class="body-2">
          <h3
            display-1
            :style="$store.state.textFormatting.main"
            class="text-xs-center"
          >
            New and recent features are ready to be used
          </h3>
          <br />
          <hr />
          <br />
          <div v-for="(entry, key) in newFeatures" :key="key">
            <p></p>
            <h4 :style="$store.state.textFormatting.main">
              {{ entry.index }}) {{ entry.header }} 
              <info v-if="entry.infotext.length>0">
                <template slot>
                    {{ entry.header }}
                </template>
                  <template slot="body">
                    <span
                      :style="$store.state.textFormatting.main"
                      v-for="item in entry.infotext"
                      :key="item"
                    >
                      {{ item }} <br>
                    </span>
                  </template>
                </info>
            </h4>
            <p></p>
            <p
              :style="$store.state.textFormatting.main"
              v-for="item in entry.body"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
        </div>
        <div class="body-2">
          <h3
            display-1
            :style="$store.state.textFormatting.main"
            class="text-xs-center"
          >
            These new features are currently being worked on
          </h3>
          <br />
          <hr />
          <br />
          <div v-for="(entry, key) in wip" :key="key">
            <p></p>
            <h4 :style="$store.state.textFormatting.main">
              {{ entry.index }}) {{ entry.header }}
            </h4>
            <p></p>
            <p
              :style="$store.state.textFormatting.main"
              v-for="item in entry.body"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
        </div>
        <div class="body-2">
          <h3
            display-1
            :style="$store.state.textFormatting.main"
            class="text-xs-center"
          >
            These are known issues which we are working to fix
          </h3>
          <br />
          <hr />
          <br />
          <div v-for="(entry, key) in knownIssues" :key="key">
            <p></p>
            <h4 :style="$store.state.textFormatting.main">
              {{ entry.index }}) {{ entry.header }}
            </h4>
            <p></p>
            <p
              :style="$store.state.textFormatting.main"
              v-for="item in entry.body"
              :key="item"
            >
              {{ item }}
            </p>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import info from "../../shared/operational/infopopout.vue";

export default {
  components: {
    info,
  },
  name: "devnotes",
  data() {
    return {
      showCard: true,
      knownIssues: [
        {
          header: "Dissagregation search is very slow",
          index: 1,
          body: [
            "Changes in the new system has slowed down the prefix dissagregation search. We are working to resolve this issue.",
          ],
          infotext: []
        },
        {
          header: "Score breakdown has temporarily been removed",
          index: 2,
          body: [
            "With the added features of the new scoring system, the score breakdown table is no longer accurate. we have temporarily removed while we work to update it.",
          ],
          infotext: []
        },
      ],
      wip: [
        {
          header: "Alert refinement",
          index: 1,
          body: [
            "We are continuously working on making alerts more targeted and reduce 'noise' in the system.",
          ],
          infotext: []
        },
      ],
      newFeatures: [
        {
          header: "NOTICE : OLD ALERT RULES TO BE REMOVED",
          index: 1,
          body: [
            "The old style ASN, Restricted Prefix and Alert Refinement rules are being phased out and replaced by the new Alert Rules (see below)",
          ],
          infotext: ["The 'ASN', 'Restricted Prefixes' and 'Alert Refinement' Rules are being replaced",
                "with 'Alert Rules'. The new Alert Rules are the initial stage for bringing in new",
                "alerting features that are not possible with the old style rules, so users need to ",
                "move their existing settings to the new format before 14th April 2022.",
                "",
                "There are two ways to acheive this:",
                "- Re-create the rules by hand in the 'Alert Rules' settings",
                "- Export your old rules and import them again in the 'Alert Rules' settings",
                "",
                "Depending on how many you have, it may be easier to re-create them so that you can make ",
                "best use of the new structure.",
                "",
                "After the 14th April, the old alerts will be disabled but still viewable",
                "After the 25th April, the old settings will be removed completely"]
        },
        {
          header: "Traceroutes",
          index: 2,
          body: [
            "The Traceroutes feature has been improved to show ASN details and the ability to run manual traceroutes.",
          ],
          infotext: ""
        },
        {
          header: "Alert Rules (new)",
          index: 3,
          body: [
            "The alerts section is going through a major update. This first release of the new Alert Rules section adds the ability to add alert rules based on a combination of Prefix / Origin ASN / Path ASN selections. This will ultimately replace the current alert settings pages but we will keep both options running for the time being"],
          infotext: [
            "The new 'Alert Rules' page can be found in the Settings drop down menu under 'Edit ASNs and Edit Restricted Prefixes'. This page bring together alerting options for Prefixes, ASNs and Paths into one place, and can be combined to build specific alerting cases that can more easily meet your needs.",
            " ",
            "The same alerting options exist for 'Ownership Assertions', 'First Seens' and 'Path Changes' along with score thresholds, but the main difference is the ability to alert on a combination of Prefixes, Origin ASNs AND Path ASNs in one rule.",
            " ",
            "The 'Prefix', 'Origin' and 'Path' sections in a Rule are treated using Boolean-like logic e.g.:",
            " ",
            " Alert on 'Ownership Assertions' where:",
            " - 'Observed Prefix is one of [aaa.bbb.ccc.ddd/nn, ...]'",
            " - AND the 'observed Origin ASN is/was one of [nnnn, ...]'",
            " - AND 'Dont care about the path'",
            " ",
            "As this suggests, you can add lists of prefixes and ASNs into the rule to save adding multiple rules for your ASNs or Prefixes of interest."
          ]
        },
      ],
    };
  },
  methods: {
    routeNewWindow: async function (input) {
      let routeData = this.$router.resolve({ name: input });
      window.open(routeData.href, "_blank");
    },
  },
};
</script>
